module.exports = __webpack_public_path__ + "static/media/Slide05.bb1133b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide05.png
// module id = 1627
// module chunks = 0